import type { PageTypeResult } from 'src/hooks/usePageType'
import { getCepHashBase64 } from 'src/utils/formatCEP'

import { dispatchAmplitudeEvent } from './dispatchAmplitudeEvent'
import { getStandardObject } from './getStandardObject'

interface DispatchCepEnteredAndConfirmedEventParams {
  pageData: PageTypeResult
  cep: string
  modalName: string
  source: string
}

export async function dispatchCepEnteredAndConfirmedEvent({
  pageData,
  cep,
  modalName,
  source,
}: DispatchCepEnteredAndConfirmedEventParams) {
  const cepHash = await getCepHashBase64(cep)

  dispatchAmplitudeEvent({
    eventName: 'CEP Entered and Confirmed',
    eventData: {
      ...getStandardObject(pageData),
      'modal name': modalName,
      'cep hash': cepHash,
      'cep source': source,
    },
  })
}

const CEP_PERSISTED_MODAL_NAME =
  'Confira as melhores ofertas e fretes para sua região!'

interface DispatchCepPersistedAppliedEventParams {
  pageData: PageTypeResult
  cep: string
  source: 'pdp' | 'cart'
}

export async function dispatchCepPersistedAppliedEvent({
  pageData,
  cep,
  source,
}: DispatchCepPersistedAppliedEventParams) {
  const cepHash = await getCepHashBase64(cep)

  if (!cepHash) {
    return
  }

  dispatchAmplitudeEvent({
    eventName: 'CEP Persisted Applied',
    eventData: {
      ...getStandardObject(pageData),
      'modal nome': CEP_PERSISTED_MODAL_NAME,
      'cep hash': cepHash,
      'cep source': source,
    },
  })
}
